module.exports = __webpack_public_path__ + "img/ServiceRobotics.0ab38ecd.svg";